import * as React from "react";
import Button from "@material-ui/core/Button";

const OnboardButton = ({ disabled, onClick }) => {
  return (
    <Button
      variant="contained"
      disabled={disabled}
      color="primary"
      onClick={onClick}
    >
      Onboard
    </Button>
  );
};

export default OnboardButton;



// WEBPACK FOOTER //
// ./src/containers/HouseholdDetail/components/OnboardButton/index.jsx